import { create } from 'zustand';

export const useSize = create((set) => ({
  isMobile: false, // whether or not the project is in mobile mode

  // set the mobile mode
  setMobile: (isMobile) => set({ isMobile }),
}));